var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5086 14.0188L12.3207 9.94177C12.5365 9.47662 12.7034 8.9976 12.8214 8.5047C12.9394 8.01182 12.9985 7.51095 12.9985 7.00208C12.9985 6.10127 12.8274 5.25474 12.4853 4.46246C12.1432 3.67019 11.6789 2.98102 11.0924 2.39496C10.5059 1.80889 9.81722 1.3451 9.0264 1.00361C8.23557 0.662111 7.39058 0.491364 6.49143 0.491364C5.59227 0.491364 4.74695 0.66235 3.95546 1.00432C3.16395 1.34629 2.47457 1.81001 1.88731 2.39549C1.30005 2.98095 0.83555 3.66961 0.493798 4.46147C0.152058 5.25331 -0.0188118 6.09938 -0.0188118 6.9997C-0.0188118 7.90003 0.152204 8.74543 0.494236 9.53591C0.836256 10.3264 1.3001 11.0153 1.88577 11.6025C2.47143 12.1898 3.16031 12.6543 3.95239 12.996C4.74448 13.3378 5.59081 13.5086 6.4914 13.5086C7.0013 13.5086 7.50252 13.4496 7.99505 13.3316C8.48759 13.2136 8.96644 13.0467 9.43159 12.8308L13.5086 14.0188ZM12.0542 12.5643L9.84212 11.9135C9.67222 11.8668 9.50842 11.8471 9.35072 11.8542C9.19303 11.8614 9.03497 11.9045 8.87656 11.9835C8.50323 12.1607 8.1151 12.296 7.71218 12.3893C7.30925 12.4827 6.90125 12.5293 6.48818 12.5293C4.95062 12.5293 3.64495 11.9925 2.57117 10.9189C1.49738 9.84524 0.960488 8.53903 0.960488 7.00023C0.960488 5.46142 1.49731 4.15512 2.57094 3.08135C3.64458 2.00756 4.9508 1.47066 6.4896 1.47066C8.02841 1.47066 9.3347 2.00751 10.4085 3.08119C11.4823 4.15486 12.0192 5.46192 12.0192 7.00236C12.0192 7.41571 11.9748 7.82401 11.8862 8.22726C11.7976 8.63049 11.6599 9.01668 11.4733 9.38581C11.3916 9.53543 11.3467 9.69369 11.3387 9.86057C11.3306 10.0275 11.3521 10.1915 11.4033 10.3526L12.0542 12.5643Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.ef34bc27fb4ab64263d85e8a73dda138.svg";
export { ForwardRef as ReactComponent };